import { getParams } from '@local-utils/common';
import dayjs from 'dayjs';

/**
 * 为埋点提供统一参数
 * 需求文档：https://alidocs.dingtalk.com/i/nodes/X6GRezwJlAQQPd5yuRna1YA78dqbropQ?utm_scene=team_space
 * - click_time: 当前点击时间，精确到时分秒
 * - gad_campaignid: 落地页 URL 中的 gad_campaignid，不存在则不上报
 * - gclid_value: 落地页 URL 中的 gclid，不存在则不上报
 */
export function getLogEventClickParams() {
  const params = {};

  const urlQuery = getParams();
  const gadCampaignId = urlQuery.gad_campaignid;
  const gclid = urlQuery.gclid;

  const timestamp = dayjs().format('YYYY-MM-DD HH:mm:ss');
  const gad_campaignid = gadCampaignId != null && gadCampaignId !== '' ? gadCampaignId : '空';
  const gclid_value = gclid != null && gclid !== '' ? gclid : '空';

  params.click_time = `${timestamp} + ${gad_campaignid} + ${gclid_value}`;

  return params;
}
